<div class="wrap">
    <app-header></app-header>
    <div class="main-holder">
        <app-nav></app-nav>
        <div class="main">
            <div class="main-content">
                <div class="bread">
                    <ol *ngIf="!showDetails">
                        <li><a [routerLink]="['/']"><img src="../../../../assets/okito/images/icons/home.svg"></a></li>
                        <img src="../../../../assets/okito/images/icons/chevron-right.svg">
                        <li><span>Service Fee Management</span></li>
                    </ol>
                    <ol *ngIf="showDetails">
                        <li><a [routerLink]="['/']"><img src="../../../../assets/okito/images/icons/home.svg"></a></li>
                        <img src="../../../../assets/okito/images/icons/chevron-right.svg">
                        <li><a (click)="returnToList()" style="cursor: pointer;">Service Fee Management</a></li>
                        <img src="../../../../assets/okito/images/icons/chevron-right.svg">
                        <li><span>{{ serviceLabel(detailViewed!.serviceType) }}</span></li>
                    </ol>
                </div>
                <div class="content-title">
                    <h2>Service Fee Management</h2>
                </div>
                <hr>

                <!-- LIST -->
                <div class="list-holder" *ngIf="!showDetails">
                    <div class="tools">
                        <div class="search mg-right-auto">
                            <span class="fee-hint">
                                One configuration per service. Services are fixed — they can be edited, not added or removed.
                            </span>
                        </div>
                    </div>
                    <div class="list">
                        <table>
                            <thead>
                                <tr>
                                    <th>Service</th>
                                    <th>Fee Type</th>
                                    <th>Service Fee</th>
                                    <th>Flat Fee</th>
                                    <th>Max Service Fee</th>
                                    <th>Affiliate Share</th>
                                    <th>Status</th>
                                    <th>Last Updated</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                <ng-container *ngIf="configs.length !== 0; else noRecords">
                                    <tr *ngFor="let config of configs">
                                        <td>{{ serviceLabel(config.serviceType) }}</td>
                                        <td>{{ config.feeType === 'flat' ? 'Flat' : 'Percentage' }}</td>
                                        <td>
                                            <span *ngIf="config.feeType !== 'flat'">{{ config.serviceFeePercentage * 100 | number:'1.0-4' }}%</span>
                                            <span *ngIf="config.feeType === 'flat'" class="fee-muted">&mdash;</span>
                                        </td>
                                        <td>
                                            <span *ngIf="config.feeType === 'flat'">&#8369;{{ config.flatFee | number:'1.2-2' }}</span>
                                            <span *ngIf="config.feeType !== 'flat'" class="fee-muted">&mdash;</span>
                                        </td>
                                        <td>
                                            <span *ngIf="config.feeType !== 'flat' && config.maxServiceFee !== null">&#8369;{{ config.maxServiceFee | number:'1.2-2' }}</span>
                                            <span *ngIf="config.feeType !== 'flat' && config.maxServiceFee === null" class="fee-muted">No cap</span>
                                            <span *ngIf="config.feeType === 'flat'" class="fee-muted">&mdash;</span>
                                        </td>
                                        <td>{{ config.affiliateSharePercentage * 100 | number:'1.0-4' }}%</td>
                                        <td>{{ config.isActive ? 'Active' : 'Inactive' }}</td>
                                        <td>{{ config.dateUpdated | date:'MM-dd-yyyy h:mm a' }}</td>
                                        <td><a (click)="viewDetails(config)" style="cursor: pointer;">View</a></td>
                                    </tr>
                                </ng-container>
                                <ng-template #noRecords>
                                    <tr>
                                        <td colspan="9" class="no-records-msg">
                                            <h6 class="ponds-contents-med-bold" *ngIf="isLoading">Loading…</h6>
                                            <h6 class="ponds-contents-med-bold" *ngIf="!isLoading && loadError === 'unsupported'">
                                                Not available on this environment yet.
                                            </h6>
                                            <h6 class="ponds-contents-med-bold" *ngIf="!isLoading && loadError === 'failed'">
                                                Connection not available. Please try again.
                                            </h6>
                                            <h6 class="ponds-contents-med-bold" *ngIf="!isLoading && loadError === 'none'">
                                                No records found
                                            </h6>
                                        </td>
                                    </tr>
                                </ng-template>
                            </tbody>
                        </table>
                    </div>
                </div>

                <!-- DETAIL / EDIT -->
                <div class="list-holder" *ngIf="showDetails && detailViewed">
                    <div class="tools">
                        <div class="search mg-right-auto"></div>
                        <div class="profile-actions">
                            <button class="btn btn-sm btn-default" style="min-width: 100px;"
                                (click)="enableEditForm()" *ngIf="!enableEdit && canManage">Edit Details</button>
                            <button class="btn btn-sm btn-default" style="min-width: 100px;"
                                [disabled]="isSaving"
                                (click)="confirmUpdate(confirmUpdateModal)" *ngIf="enableEdit">Save</button>
                            <button class="btn btn-sm btn-outline" style="min-width: 100px;"
                                [disabled]="isSaving"
                                (click)="disableEditForm()" *ngIf="enableEdit">Cancel</button>
                            <button class="btn btn-sm btn-outline" style="min-width: 100px;"
                                (click)="returnToList()" *ngIf="!enableEdit">Back to List</button>
                        </div>
                    </div>

                    <div class="panel">
                        <div class="panel-info">
                            <div class="form-item">
                                <label class="form-label">Service</label>
                                <!-- Identifies which configuration this is, so it is never editable. -->
                                <input type="text" class="form-control"
                                    [value]="serviceLabel(detailViewed.serviceType)" disabled="true">
                            </div>

                            <div class="form-item">
                                <label class="form-label">Fee Type</label>
                                <select class="form-select" [disabled]="!enableEdit" [(ngModel)]="form.feeType">
                                    <option value="percentage">Percentage &mdash; a share of the fare</option>
                                    <option value="flat">Flat &mdash; a fixed amount per booking</option>
                                </select>
                            </div>

                            <div class="form-item" *ngIf="!isFlatFee">
                                <label class="form-label">Service Fee (%)</label>
                                <input type="number" class="form-control" min="0" max="100" step="0.01"
                                    placeholder="e.g. 10 for 10%"
                                    [(ngModel)]="form.serviceFeePercentage" [disabled]="!enableEdit">
                                <small class="fee-hint">Share of the fare charged as the service fee.</small>
                            </div>

                            <div class="form-item" *ngIf="isFlatFee">
                                <label class="form-label">Flat Fee (&#8369;)</label>
                                <input type="number" class="form-control" min="0" step="0.01"
                                    placeholder="e.g. 40.00"
                                    [(ngModel)]="form.flatFee" [disabled]="!enableEdit">
                                <small class="fee-hint">Charged once per booking, whatever the fare.</small>
                            </div>

                            <div class="form-item" *ngIf="!isFlatFee">
                                <label class="form-label">Maximum Service Fee (&#8369;)</label>
                                <input type="number" class="form-control" min="0" step="0.01"
                                    placeholder="Leave blank for no cap"
                                    [(ngModel)]="form.maxServiceFee" [disabled]="!enableEdit">
                                <small class="fee-hint">
                                    Caps the computed fee. Leave blank for no cap. Does not apply to a flat fee.
                                </small>
                            </div>

                            <div class="form-item">
                                <label class="form-label">Affiliate Share (%)</label>
                                <input type="number" class="form-control" min="0" max="100" step="0.01"
                                    placeholder="e.g. 5 for 5%"
                                    [(ngModel)]="form.affiliateSharePercentage" [disabled]="!enableEdit">
                                <small class="fee-hint">
                                    Share of the charged service fee paid to an affiliate referrer.
                                </small>
                            </div>

                            <div class="form-item">
                                <label class="form-label">Status</label>
                                <select class="form-select" [disabled]="!enableEdit" [(ngModel)]="form.isActive">
                                    <option [ngValue]="true">Active</option>
                                    <option [ngValue]="false">Inactive</option>
                                </select>
                            </div>

                            <div class="form-item">
                                <label class="form-label">Last Updated</label>
                                <input type="text" class="form-control"
                                    [value]="(detailViewed.dateUpdated | date:'MM-dd-yyyy h:mm a') || ''"
                                    disabled="true">
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>

<ng-template #confirmUpdateModal let-modal class="modal">
    <div class="modal-header">
        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
    </div>
    <div class="modal-body">
        <p>
            Are you sure you want to update the service fee for
            <strong>{{ serviceLabel(detailViewed!.serviceType) }}</strong>?
            This applies to every new booking on that service.
        </p>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline" (click)="modal.dismiss('Cross click')">No, Cancel it</button>
        <button type="button" class="btn btn-default" [disabled]="isSaving"
            (click)="updateConfig(successUpdateModal)">Yes, Update</button>
    </div>
</ng-template>

<ng-template #successUpdateModal let-modal class="modal">
    <div class="modal-header">
        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
    </div>
    <div class="modal-body success-body">
        <img src="../../../../assets/okito/images/modal-success.svg">
        <p>Service fee successfully updated</p>
        <button class="btn btn-default" (click)="closeAllModals()">Close</button>
    </div>
</ng-template>
